// generated by genversion
export var version = '3.8.18';
//# sourceMappingURL=version.js.map